import notification from "../media/audio/notification.mp3";

export default {
  NOTIFICATION: notification
}